import Component from 'Spackle/Components/Component';
import AjaxLoader from 'Spackle/Loaders/AjaxLoader';
import Roles from './Roles';
import Bio from './Bio';
import GeneralInfo from './GeneralInfo';
import Photo from './Photo';
import Settings from './Settings';
import Unsubscribes from './Unsubscribes';
import ReviewStats from './ReviewStats';
import Orgs from './Orgs';
import Groups from './Groups';
import AdvancedTools from './AdvancedTools';
import DisableUser from './DisableUser';
import Alerts from './Alerts';
import ProfileHeader from './ProfileHeader';

export default class UserProfilePage extends Component {
    templateId() {
        return '#userProfilePageTemplate';
    }

    load(containerId) {
        $(containerId).html($(this.templateId()).html());

        $('[data-toggle="tooltip"]').tooltip();
        $(window).on('resize', this.doResize);

        var loader = new AjaxLoader;
        var roles = new Roles(loader);
        var bio = new Bio(loader);
        var generalInfo = new GeneralInfo(loader);
        var photo = new Photo(loader);
        var settings = new Settings(loader);
        var unsubscribes = new Unsubscribes(loader);
        var reviewStats = new ReviewStats(loader);
        var orgs = new Orgs(loader);
        var groups = new Groups(loader);
        var advancedTools = new AdvancedTools(loader);
        var disableUser = new DisableUser(loader);
        var alerts = new Alerts(loader);
        var profileHeader = new ProfileHeader(loader);
        bio.load('#bio');
        generalInfo.load('#generalInfo');
        photo.load('#photo');
        roles.load('#roles');
        settings.load('#settings');
        unsubscribes.load('#unsubscribes');
        reviewStats.load('#reviewStats');
        orgs.load('#orgs');
        groups.load('#groups');
        advancedTools.load('#advancedTools');
        disableUser.load('#disableUser');
        alerts.load('#alerts');
        profileHeader.load('#profileHeader');
        this.doResize();

        $(containerId).removeClass('loading').trigger('load.rendered');
    }

    doResize() {
        $('#bio').on('load.rendered', function () {
            $('.bioText').dotdotdot();
        });
    }
}
